import type { IModule } from "../security/models/module-model";

export default <IModule>{
  routes: [
    {
      path: "/module/settings",
      name: "settings",
      meta: { requiresAuth: true, title: "routes.settings" },
      component: () => import("./main.vue")
    },
    {
      path: "/module/settings/institution",
      name: "institutionsetup",
      meta: { requiresAuth: true, title: "routes.institution" },
      component: () => import("./institution.vue")
    },
    {
      path: "/module/settings/eventcategories",
      name: "eventcategories",
      meta: { requiresAuth: true, title: "routes.eventCategories" },
      component: () => import("./eventcategories.vue")
    },
    {
      path: "/module/settings/positions",
      name: "positions",
      meta: { requiresAuth: true, title: "routes.positions" },
      component: () => import("./positions.vue")
    },
    {
      path: "/module/settings/salaryandabsence",
      name: "salaryandabsence",
      meta: { requiresAuth: true, title: "routes.salaryAndAbsenceTypes" },
      component: () => import("./salaryandabsence.vue")
    },
    {
      path: "/module/settings/departments",
      name: "departments",
      meta: { requiresAuth: true, title: "routes.departments" },
      component: () => import("./departments.vue")
    }
  ]
};
